import { render, staticRenderFns } from "./AvatarsGroup.vue?vue&type=template&id=f98f3bd4&scoped=true&"
import script from "./AvatarsGroup.vue?vue&type=script&lang=js&"
export * from "./AvatarsGroup.vue?vue&type=script&lang=js&"
import style0 from "./AvatarsGroup.vue?vue&type=style&index=0&id=f98f3bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f3bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})
